import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

export const client = new ApolloClient({
  link: new HttpLink({
    uri: 'https://hasura-graphql.highso.app/v1/graphql',
  }),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});